<ng-container *ngIf="isLoading">
    <div class="loaderbx-full">
            <div class="loader insight">
                <div class="insight-loader">
                    <img class="outer" nwnCdnClient="insight-loader-os.png" [fromBase]="true" alt="Outer loader image" />
                    <img class="inner" nwnCdnClient="insight-loader-is.png" [fromBase]="true" alt="Inner loader image" />
                </div>
                <span>Loading...</span>
            </div>
        </div>
</ng-container>